import { useEffect } from 'react'
import { useMap } from 'react-leaflet'

// Drop this inside a <MapContainer scrollWheelZoom={false}> to make wheel-zoom
// require holding Ctrl (or Cmd on macOS). Plain scrolling then passes through to
// the page instead of being captured by the map. A short hint overlay is shown
// when the user scrolls over the map without the modifier held.
const HINT_TEXT = 'Pro přiblížení podržte Ctrl a otáčejte kolečkem'

const CtrlScrollZoom = ({ hintText = HINT_TEXT }) => {
  const map = useMap()

  useEffect(() => {
    map.scrollWheelZoom.disable()

    const container = map.getContainer()

    const hint = document.createElement('div')
    hint.textContent = hintText
    Object.assign(hint.style, {
      position: 'absolute',
      inset: '0',
      zIndex: '1000',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      textAlign: 'center',
      color: '#fff',
      fontSize: '1.25rem',
      fontWeight: '600',
      background: 'rgba(0, 0, 0, 0.45)',
      opacity: '0',
      pointerEvents: 'none',
      transition: 'opacity 0.2s ease',
    })
    container.appendChild(hint)

    let hideTimer = null
    const showHint = () => {
      hint.style.opacity = '1'
      clearTimeout(hideTimer)
      hideTimer = setTimeout(() => { hint.style.opacity = '0' }, 1200)
    }
    const hideHint = () => {
      hint.style.opacity = '0'
      clearTimeout(hideTimer)
    }

    const enableZoom = (event) => {
      if (event.key === 'Control' || event.key === 'Meta') {
        map.scrollWheelZoom.enable()
        hideHint()
      }
    }
    const disableZoom = (event) => {
      if (!event || event.key === 'Control' || event.key === 'Meta') {
        map.scrollWheelZoom.disable()
      }
    }

    const onWheel = (event) => {
      if (event.ctrlKey || event.metaKey) {
        // Leaflet handles the actual zoom; just make sure it is enabled.
        if (!map.scrollWheelZoom.enabled()) map.scrollWheelZoom.enable()
        hideHint()
      } else {
        showHint()
      }
    }

    document.addEventListener('keydown', enableZoom)
    document.addEventListener('keyup', disableZoom)
    window.addEventListener('blur', disableZoom)
    container.addEventListener('wheel', onWheel, { passive: true })

    return () => {
      document.removeEventListener('keydown', enableZoom)
      document.removeEventListener('keyup', disableZoom)
      window.removeEventListener('blur', disableZoom)
      container.removeEventListener('wheel', onWheel)
      clearTimeout(hideTimer)
      hint.remove()
    }
  }, [map, hintText])

  return null
}

export default CtrlScrollZoom
